import { ReadRelatorioAtividadeDto } from '@/api.types';

export interface DefensoriaOpcao {
  id: number;
  nome: string;
  comarca: string;
  criminal?: boolean;
  civel?: boolean;
}

/**
 * Tipo base vem do OpenAPI (`ReadRelatorioAtividadeDto`).
 *
 * Observação: hoje o schema gerado tipa `tipo/status/dados` como `Record<string, never>`
 * (por não estarem descritos como enum/objeto no OpenAPI). Aqui fazemos o "override"
 * para manter os unions usados na UI, sem duplicar toda a interface manualmente.
 */
export type RelatorioAtividadeDto = Omit<
  ReadRelatorioAtividadeDto,
  'tipo' | 'status' | 'dados' | 'mes' | 'defensoriaName' | 'defensorNome' | 'periodo'
> & {
  tipo: 'civil' | 'criminal';
  status: 'rascunho' | 'pendente' | 'enviado' | 'aprovado' | 'reprovado';
  dados?: any;

  mes: number | string;

  defensoriaName: string;
  defensorNome?: string;
  periodo: string;

  dataCriacao: string;
  dataAtualizacao?: string;
  editadoPorNome?: string;

  /** Diretoria regional à qual o relatório foi encaminhado (enviado); alinha com a API. */
  diretoriaRegionalId?: number;
  diretoriaRegionalNome?: string;

  /** Dias de comparecimento de relatórios adjacentes concluídos (exibição no calendário). */
  diasComparecimentoAdjacentes?: Array<{
    dia: number;
    mes: string;
    ano: number;
    status: string;
    remotoValidado?: boolean;
    ausenteAceitoCorregedoria?: boolean;
    relatorioOrigemId: number;
    relatorioOrigemPeriodo: string;
  }>;
};

/** Corregedoria devolveu ao defensor: após correções o envio é direto à Corregedoria (sem novo trâmite pelo diretor). */
export function isReenvioDiretoCorregedoriaPendente(r: RelatorioAtividadeDto): boolean {
  return r.status === 'reprovado' && r.dados?.reenvioDiretoCorregedoriaPendente === true;
}

export interface LotacaoTitular {
  tipo: string;
  nome: string;
  tipoAbreviado: string;
}
